import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { TransactionService } from '../services/transaction.service';
import {
  fetchTransactionList,
  loadedTransactionList,
  failedTransactionList,
  updateTransactionListFilter,
} from './transaction-list.actions';
import { selectTransactionListFilter } from './transaction-list.selector';

@Injectable()
export class TransactionListEffect {
  loadTransactionList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchTransactionList),
      switchMap(({ filter }) =>
        this.transactionService.getTransactionList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedTransactionList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedTransactionList();
            }
          }),
          catchError(() => of(failedTransactionList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateTransactionListFilter),
      concatLatestFrom(() => this.store.select(selectTransactionListFilter)),
      switchMap(([action, prevFilter]) =>
        of(
          fetchTransactionList({ filter: { ...prevFilter, ...action.filter } })
        )
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly transactionService: TransactionService
  ) {}
}
